import React, { useState, useEffect } from "react";
import {  useNavigate } from "react-router-dom";
import "../assets/styles/main.css";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrency,
  setCurrency,
} from "../components/Redux/Slices/currencySlice";
import CountryFlag from "react-country-flag";
import { db } from "../db";
import PaginationEntriesPerPage from "../components/PaginationEntriesPerPage";
import CurrencyModal from "../components/CurrencyModal";
import ErrorSuccessMessage from "../components/ErrorSuccessMessage";

function Settings() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [progress, setProgress] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [userName, setUserName] = useState(localStorage.getItem("username"));
  const selectedCurrency = useSelector(selectCurrency);
  const dispatch = useDispatch();
  const [intervalId, setIntervalId] = useState(null);
  const [totalExpensesCount, setTotalExpensesCount] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [temporarySelectedCurrency, setTemporarySelectedCurrency] =
    useState(selectedCurrency);
  const handleCloseConfirmation = () => setShowConfirmation(false);
  const handleShowConfirmation = () => setShowConfirmation(true);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const storedValue = localStorage.getItem("itemsPerPage") || 10;
    return parseInt(storedValue);
  });
  const appVersion = localStorage.getItem("appVersion");

  const handleCurrencyChange = (currency) => {
    setTemporarySelectedCurrency(currency);
  };
  const handleConfirmCurrencyChange = () => {
    handleCloseConfirmation();
    setMessage("Successfully updated");
    setMessageType("success");
    if (temporarySelectedCurrency) {
      localStorage.setItem(
        "selectedCurrency",
        JSON.stringify(temporarySelectedCurrency)
      );
      dispatch(setCurrency(temporarySelectedCurrency));
    }
    clearExpensesFromDB();
    startCountdown();
    setTimeout(() => {
      setMessage("");
      setMessageType("");
    }, 1000);
  };

  const handleSaveClick = (e) => {
    e.preventDefault();

    const currentUserName = localStorage.getItem("username");
    const currentItemsPerPage = localStorage.getItem("itemsPerPage");

    if (
      userName !== currentUserName ||
      itemsPerPage.toString() !== currentItemsPerPage
    ) {
      setMessage("Successfully updated");
      setMessageType("success");
      startCountdown();

      localStorage.setItem("itemsPerPage", itemsPerPage.toString());
      localStorage.setItem("username", userName);
    }

    if (temporarySelectedCurrency !== selectedCurrency) {
      handleShowConfirmation();
    }
    setTimeout(() => {
      setMessage("");
      setMessageType("");
    }, 1000);
  };

  const clearExpensesFromDB = () => {
    db.expenses
      .toCollection()
      .delete()
      .then(() => {
        console.log("Expenses cleared from IndexedDB");
      })
      .catch((error) => {
        console.error("Error clearing expenses from IndexedDB:", error);
      });
  };

  const changeItemsPerPage = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setItemsPerPage(totalExpensesCount);
    } else {
      const intValue = parseInt(value);
      setItemsPerPage(intValue);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const currencyOptions = [
    { code: "Australian Dollar", label: "$", flag: "AU" },
    { code: "Brazilian Real", label: "R$", flag: "BR" },
    { code: "Canadian Dollar", label: "$", flag: "CA" },
    { code: "Swiss Franc", label: "CHF", flag: "CH" },
    { code: "Chinese Yuan", label: "¥", flag: "CN" },
    { code: "Euro", label: "€", flag: "EU" },
    { code: "British Pound", label: "£", flag: "GB" },
    { code: "Hong Kong Dollar", label: "$", flag: "HK" },
    { code: "Indian Rupee", label: "₹", flag: "IN" },
    { code: "Japanese Yen", label: "¥", flag: "JP" },
    { code: "South Korean Won", label: "₩", flag: "KR" },
    { code: "Mexican Peso", label: "$", flag: "MX" },
    { code: "Norwegian Krone", label: "kr", flag: "NO" },
    { code: "New Zealand Dollar", label: "$", flag: "NZ" },
    { code: "Russian Ruble", label: "₽", flag: "RU" },
    { code: "Saudi Riyal", label: "ر.س", flag: "SA" },
    { code: "Singapore Dollar", label: "$", flag: "SG" },
    { code: "Swedish Krona", label: "kr", flag: "SE" },
    { code: "Turkish Lira", label: "₺", flag: "TR" },
    { code: "US Dollar", label: "$", flag: "US" },
    { code: "South African Rand", label: "R", flag: "ZA" },
  ];

  useEffect(() => {
    db.expenses
      .count()
      .then((count) => {
        setTotalExpensesCount(count);
      })
      .catch((error) => {
        console.error("Error fetching total expenses count:", error);
      });
  }, []);
  const startCountdown = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIsActive(true);
    setProgress(0);

    let currentProgress = 0;
    const newIntervalId = setInterval(() => {
      currentProgress += 100 / (1 * 10);
      setProgress(currentProgress);
    }, 100);

    setIntervalId(newIntervalId);
  };

  return (
    <div className="container main-div">
      <div className="display-center pb-2">
        <button
          className="btn verticalAlign position-absolute start-0 "
          onClick={() => {
            navigate(-1);
          }}
        >
          <span className="fs-1  material-symbols-outlined">
            chevron_backward
          </span>
        </button>
        <h3 className=" verticalAlign heading-txt">Settings </h3>
      </div>

      <div className="card child-div    ">
        <form onSubmit={handleSubmit}>
          <div className="row mb-5 ">
            <div className="app-version mb-3">
              <label className="form-label noSpace ">
                App version: <span className="text-muted">{appVersion}</span>
              </label>
            </div>
            <div className="col setting-col  mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                value={userName}
                required
                onChange={(e) => setUserName(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="col setting-col  mb-4">
              <label className="form-label noSpace">Change Currency</label>
              <Dropdown>
                <Dropdown.Toggle
                  className="button-div w-100 p-2 form-control display-between"
                  variant="light"
                  id="currency-dropdown "
                >
                  {temporarySelectedCurrency ? (
                    <>
                      <span>
                        <CountryFlag
                          countryCode={temporarySelectedCurrency.flag}
                          svg
                        />
                        <span className="ms-2">
                          {temporarySelectedCurrency.code}
                          <span className="ms-1 currencyIcons">
                            {temporarySelectedCurrency.label}
                          </span>
                        </span>
                      </span>
                    </>
                  ) : (
                    "Select Currency"
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100 form-control ">
                  {currencyOptions.map((currency) => (
                    <Dropdown.Item
                      key={`${currency.code}`}
                      onClick={() => handleCurrencyChange(currency)}
                      active={selectedCurrency?.code === currency?.code}
                    >
                      <CountryFlag countryCode={currency.flag} svg />
                      <span className="ms-2 ">{currency?.code} </span>
                      {currency?.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="col setting-col  mb-3">
              <label className="form-label noSpace">Entries Per Page</label>
              <PaginationEntriesPerPage
                value={itemsPerPage}
                totalCount={totalExpensesCount}
                onChange={changeItemsPerPage}
              />
            </div>
            <div className="col setting-col  mb-4">
              <label className="form-label noSpace">Tools</label>
              <div>
                <button
                  className="btn setting-btn rounded-pill nowrap"
                  onClick={() => navigate("/admin-panel")}
                >
                  Admin Panel
                </button>
              </div>
            </div>
          </div>
        </form>
        <div className="pt-4 ">
          {" "}
          <button
            type="submit"
            className="btn save-btn button-position rounded-pill "
            onClick={handleSaveClick}
          >
            <span className="material-symbols-outlined verticalAlign me-2">
              save
            </span>
            <span className="verticalAlign">Save</span>
          </button>
          <ErrorSuccessMessage
            message={message}
            messageType={messageType}
            isActive={isActive}
            progress={progress}
          />
        </div>
      </div>
      <CurrencyModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmCurrencyChange}
        selectedCurrency={selectedCurrency}
        temporarySelectedCurrency={temporarySelectedCurrency}
      />
    </div>
  );
}

export default Settings;
